import { queryClient } from "./queryClient";
import { supabase } from "./supabase";
import { AuthError, reportTechnicalError } from "./errors";

let refreshPromise: Promise<string | null> | null = null;
let expiryPromise: Promise<void> | null = null;

export async function getAccessToken() {
  if (!supabase) return "demo-token";
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    reportTechnicalError(error, "auth.getSession");
    return null;
  }
  return data.session?.access_token ?? null;
}
export async function refreshAccessToken() {
  if (!supabase) return "demo-token";
  if (!refreshPromise) {
    refreshPromise = supabase.auth.refreshSession()
      .then(({ data, error }) => {
        if (error) {
          reportTechnicalError(error, "auth.refreshSession");
          return null;
        }
        return data.session?.access_token ?? null;
      })
      .catch((error) => {
        reportTechnicalError(error, "auth.refreshSession");
        return null;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

export async function expireSession() {
  if (expiryPromise) return expiryPromise;
  expiryPromise = (async () => {
    try {
      if (supabase) await supabase.auth.signOut({ scope: "local" });
    } catch (error) {
      reportTechnicalError(error, "auth.expireSession.signOut");
    } finally {
      queryClient.clear();
      if (
        typeof window !== "undefined"
        && !(window.location.pathname === "/login" && window.location.search.includes("reason=session-expired"))
      ) {
        window.location.replace("/login?reason=session-expired");
      }
    }
  })();
  return expiryPromise;
}

export const sessionCoordinator = {
  getAccessToken,
  refreshAccessToken,
  expireSession,
};

export function sessionExpiredError(technicalMessage?: string) {
  return new AuthError({
    code: "SESSION_EXPIRED",
    userMessage: "登录状态已过期，请重新登录",
    technicalMessage,
    status: 401,
    retryable: false,
  });
}

export function resetSessionLifecycleForTests() {
  refreshPromise = null;
  expiryPromise = null;
}
